var exports = {
  "F": "x0a7806d5--071db9--button-container",
  "x": "x0a7806d5--071db9--button",
};

module.exports = exports;
